import React, { useEffect, useState } from "react";
import styled from "styled-components";
import logo from "../assets/logo.svg";
import menu from "../assets/ic_menu.svg";

function NavbarMobile({ show }) {
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    if (!show) setMenuOpen(false);
  }, [show]);
  return (
    <MainContainer show={show ? "true" : "false"}>
      <Logo src={logo} />
      <MenuIcon
        src={menu}
        onClick={() => {
          setMenuOpen(!menuOpen);
        }}
      />
      <MenuContainer open={menuOpen ? "true" : "false"}>
        <Menu href="#home">홈</Menu>
        <Menu href="#with-js-lap">with js Lap</Menu>
        <Menu href="#introduction">소개</Menu>
        <Menu href="#process">프로세스</Menu>
        <Menu href="#faq">FAQ</Menu>
      </MenuContainer>
    </MainContainer>
  );
}

export default NavbarMobile;
const MainContainer = styled.div`
  position: fixed;
  top: ${(props) => (props.show === "true" ? 0 : "-62px")};
  width: 100vw;
  height: 91px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 1000;
  transition: 0.3s ease;
`;
const Logo = styled.img`
  width: 166px;
  height: 36px;
  margin-left: 25px;
`;
const MenuIcon = styled.img`
  cursor: pointer;
  width: 24px;
  height: 24px;
  margin-right: 25px;
`;
const MenuContainer = styled.div`
  position: fixed;
  right: 22px;
  top: 70px;
  background: white;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  box-shadow: 0px 10px 20px #00000020;
  opacity: ${(props) => (props.open === "true" ? 1 : 0)};
  transition: 0.3s ease;
  padding: 20px;
`;
const Menu = styled.a`
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: end;
  color: #000;
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px; /* 200% */
  text-decoration: none;
`;
